<h1 mat-dialog-title style="color: #f44336">{{ data.title }}</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions style="display: flex; justify-content: center">
  <button mat-flat-button color="primary" (click)="onOkClick()">關閉</button>
</div>
